import clsx from "clsx";

const baseStyles =
  "flex flex-row gap-2 items-center justify-center rounded-4xl text-body font-body font-medium lg:text-lg text-base transition duration-300 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed content-initial";

const variants = {
  primary: "bg-primary-200 text-dark-900 hover:bg-primary-400 hover:text-dark-900 px-3 py-2 md:px-4 md:py-2.5 ",
  secondary: "bg-transparent text-darkblue hover:bg-lightgrey px-3 py-2 md:px-4 md:py-2.5",
  breadcrumb: "bg-transparent text-dark-400",
  outline: "text-light bg-dark-900 px-3 py-1 ",
};

export default function Button({
  children,
  variant = "primary",
  icon: Icon,
  iconPosition = "left",
  iconClassName = "",
  className = "",
  ...props
}) {
  return (
    <button
      {...props}
      className={clsx(baseStyles, variants[variant], className)}
    >
      {Icon && iconPosition === "left" && (<Icon className={iconClassName} />)}
      {children}
      {Icon && iconPosition === "right" && (<Icon className={iconClassName} />)}
    </button>
  );
}